import { useSelector, useDispatch } from "react-redux";
import React, { useState } from "react";
import Icon from "@mdi/react";
import { mdiMagnify, mdiTuneVariant } from "@mdi/js";
import { Dropdown, Table } from "react-bootstrap";
import { DateTimePicker } from "react-widgets";
import moment from "moment";
import "moment/locale/vi";
import LangugeVi from "constants/vi";

import {
  getListDanhSachDonDatHang,
  updateDataSearch,
} from "../../../actions/DanhSachDonDatHang";

import { getBranch, utilsOnChangeSelectTypeDate } from "utils/utils";

moment.locale("vi", LangugeVi.VietNamese);

export default function SearchDonDatHang({
  isModalVisible,
  toggleModal,
  selected,
  setSelected,
  listTextSearch,
  setListTextSearch,
  dateFromNew,
  setDateFromNew,
  dateToNew,
  setDateToNew,
}) {
  const dispatch = useDispatch();

  const dataSearch = useSelector((state) => state.dataSearchDanhSachDonDatHang);
  const listDonHang = useSelector((state) => state.listDanhSachDonDatHang);

  const listTime = [
    { key: "1", value: "Hôm nay" },
    { key: "2", value: "Hôm qua" },
    { key: "3", value: "Tuần này" },
    { key: "4", value: "Tuần trước" },
    { key: "5", value: "Tháng này" },
    { key: "6", value: "Tháng trước" },
    { key: "7", value: "Quý này" },
    { key: "8", value: "Quý trước" },
    { key: "9", value: "Năm này" },
    { key: "10", value: "Năm trước" },
    { key: "11", value: "Tuỳ chỉnh thời gian" },
  ];

  const [showSelectThoiGian, setShowSelectThoiGian] = useState(false);

  const [doubleClick, setDoubleClick] = useState(false);
  const currentTimeKey = selected?.key || "11";

  const updateState = (field, text) => {
    dispatch(
      updateDataSearch({
        ...dataSearch,
        [field]: text,
      }),
    );
  };

  const updateTextValue = (field) => (e) => {
    updateState(field, e.target.value);
  };

  const updateDropdown = (field) => (e) => {
    updateState(field, e.target.value);
  };

  const onChangeDateFrom = (field) => (e) => {
    setDateFromNew(e);
    updateState(field, moment(e).format("YYYY-MM-DD"));
  };

  const onChangeDateTo = (field) => (e) => {
    setDateToNew(e);
    updateState(field, moment(e).format("YYYY-MM-DD"));
  };

  const handleSelectTime = (key, value) => {
    setSelected({ key, value });

    if (key === "11") {
      setShowSelectThoiGian(true);
    } else {
      setShowSelectThoiGian(false);
    }

    const thongtin = { ...dataSearch };
    thongtin.typeDate = key;
    thongtin.iPageIndex = 1;
    utilsOnChangeSelectTypeDate(thongtin);

    dispatch(
      updateDataSearch({
        ...thongtin,
        typeDate: key,
        iPageIndex: 1,
      }),
    );
  };

  const loadTop = () => {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  };

  const onSearch = () => {
    setDoubleClick(true);
    toggleModal(false);

    if (getBranch() === 0 || getBranch() === "0") {
      const cate = { ...listDonHang };
      let strBranch = "";

      if (cate.List2) {
        cate.List2.map((row) => {
          if (row.IsCheck === 1) {
            strBranch = strBranch + "_" + row.BranchID;
          }
          return row;
        });
      }

      const searchNew = {
        ...dataSearch,
        sBranch: strBranch,
        iPageIndex: 1,
      };

      dispatch(updateDataSearch(searchNew));
      dispatch(getListDanhSachDonDatHang(searchNew));
    } else {
      const searchNew = {
        ...dataSearch,
        iPageIndex: 1,
      };

      dispatch(updateDataSearch(searchNew));
      dispatch(getListDanhSachDonDatHang(searchNew));
    }

    loadTop();

    const obj1 = {
      name: dataSearch.sSearch,
      field: "sSearch",
    };

    const obj2 = {
      sTrangThai: dataSearch.sTrangThai || "0",
      field: "sTrangThai",
    };

    const obj3 = {
      name: dataSearch.typeDate || "11",
      tuNgay: dataSearch.tuNgay || dataSearch.fromDate,
      denNgay: dataSearch.denNgay || dataSearch.toDate,
      field: "typeDate",
    };

    setListTextSearch({
      ...listTextSearch,
      List: [obj1, obj2, obj3],
    });

    setDoubleClick(false);
  };

  const resetSearch = () => {
    const thongtin = { ...dataSearch };
    thongtin.sSearch = "";
    thongtin.sTrangThai = "-1";
    thongtin.typeDate = "11";
    thongtin.iPageIndex = 1;
    utilsOnChangeSelectTypeDate(thongtin);

    setSelected({
      key: "11",
      value: "Tùy chỉnh thời gian",
    });

    dispatch(updateDataSearch(thongtin));
    setListTextSearch({ List: [] });
    toggleModal(false);
  };

  return (
    <div className="don-search-ver2">
      <div className="don-search-main">
        <input
          type="text"
          value={dataSearch.sSearch || ""}
          onChange={updateTextValue("sSearch")}
          placeholder="Mã đơn đặt hàng"
          onKeyDown={(e) => e.key === "Enter" && onSearch()}
        />

        <button
          className="don-search-filter-btn"
          onClick={() => toggleModal(!isModalVisible)}
        >
          <Icon path={mdiTuneVariant} size={1} />
        </button>

        <button className="don-search-icon-btn" onClick={onSearch}>
          <Icon path={mdiMagnify} size={1.2} />
        </button>
      </div>

      {isModalVisible && (
        <div className="don-search-dropdown">
          <div className="don-search-dropdown-body">
            {/* <div className="don-search-field">
              <label>Trạng thái</label>

              <select
                value={dataSearch.sTrangThai || "-1"}
                onChange={updateDropdown("sTrangThai")}
              >
                <option value="-1">Tất cả</option>
                <option value="0">Chờ chốt</option>
                <option value="1">Đã chốt</option>
                <option value="2">Không chốt</option>
                <option value="3">Lên đơn 1 phần</option>
                <option value="4">Hoàn thành</option>
              </select>
            </div> */}

            <div className="don-search-field">
              <label>Thời gian</label>

              <Dropdown
                show={showSelectThoiGian}
                onToggle={(show) => setShowSelectThoiGian(show)}
              >
                <Dropdown.Toggle
                  id="dropdown-don-date"
                  className="don-search-time-toggle"
                >
                  {selected?.value || "Tùy chỉnh thời gian"}
                </Dropdown.Toggle>

                <Dropdown.Menu
                  className={currentTimeKey === "11" ? "has-custom-time" : ""}
                >
                  <Table borderless style={{ marginBottom: 0 }}>
                    <tbody>
                      <tr>
                        <td>
                          {listTime.map((item) => (
                            <Dropdown.Item
                              className={
                                currentTimeKey === item.key
                                  ? item.key === "11"
                                    ? "active-custom"
                                    : "active-time"
                                  : ""
                              }
                              key={item.key}
                              eventKey={item.key}
                              onSelect={() =>
                                handleSelectTime(item.key, item.value)
                              }
                            >
                              {item.value}
                            </Dropdown.Item>
                          ))}
                        </td>

                        {currentTimeKey === "11" && (
                          <td className="don-date-custom-cell">
                            <div className="don-date-custom">
                              <div>
                                <label>Từ ngày</label>
                                <DateTimePicker
                                  format="DD/MM/YYYY"
                                  time={false}
                                  onChange={onChangeDateFrom("tuNgay")}
                                  value={dateFromNew}
                                  culture="vi"
                                />
                              </div>

                              <div>
                                <label>Đến ngày</label>
                                <DateTimePicker
                                  format="DD/MM/YYYY"
                                  time={false}
                                  onChange={onChangeDateTo("denNgay")}
                                  value={dateToNew}
                                  culture="vi"
                                />
                              </div>

                              <div className="don-date-custom-actions">
                                <button
                                  type="button"
                                  onClick={() =>
                                    handleSelectTime("1", "Hôm nay")
                                  }
                                >
                                  Huỷ
                                </button>

                                <button
                                  type="button"
                                  onClick={() => setShowSelectThoiGian(false)}
                                >
                                  Áp dụng
                                </button>
                              </div>
                            </div>
                          </td>
                        )}
                      </tr>
                    </tbody>
                  </Table>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>

          <div className="don-search-dropdown-footer">
            <button
              type="button"
              className="don-skip-btn"
              onClick={resetSearch}
            >
              Bỏ qua
            </button>

            <button
              type="button"
              className="don-search-submit-btn"
              onClick={onSearch}
              disabled={doubleClick}
            >
              <Icon path={mdiMagnify} size={0.9} />
              Tìm kiếm
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
